module.exports = __webpack_public_path__ + "static/media/YM47_2.ca533496.jpg";